// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__N9ggA","column":"style_column__21Ozi","row":"style_row__Iihw6"};